import { Component, OnInit } from '@angular/core';
import { CurrencyRateService } from './currency-rate-service';
import {RateWithRebate} from "./model/rate-with-rebate";

let $ : any = require("jquery");

@Component({
    selector: 'dk-currency-rates',
    template: require('./currency-rates.html'),
    providers: [ CurrencyRateService ]
})

export class CurrencyRatesComponent implements OnInit {
    rates: RateWithRebate[];
    errorMessage: string;
    loaded: boolean = false;
    currentPosition: number = 0;
    seconds: number;

    constructor(
        private currencyRateService: CurrencyRateService
    ) {

    }

    ngOnInit() {
        this.currencyRateService.getCurrencyRatesSubject().subscribe(
            rates => {
                if (typeof rates === 'number') {
                    this.seconds = rates;
                } else {
                    this.rates = rates;
                    this.seconds = 15;
                }
                this.loaded = true;
            },
            error =>  this.errorMessage = <any>error);
    }

    onMoveLeft() {
        if (this.currentPosition === 0) {
            this.currentPosition = this.rates.length - 4;
        } else {
            this.currentPosition -= 4;
        }

        if (this.currentPosition < 0) {
            this.currentPosition = 0;
        }

        $("#currency-rates-container").animate({scrollLeft : this.currentPosition * ($("#currency-rates-container").children().first().width() + 10)});
    }

    onMoveRight() {
        this.currentPosition += 4;

        if (this.currentPosition >= this.rates.length - 1) {
            this.currentPosition = 0;
        }

        if (this.currentPosition + 4 > this.rates.length - 1) {
            this.currentPosition = this.rates.length - 4;
        }

        $("#currency-rates-container").animate({scrollLeft : this.currentPosition * ($("#currency-rates-container").children().first().width() + 10)});
    }
}
